import { useMemo } from 'react'
import { useFullAuthzContext } from './AuthzContextProvider'
import { resolveAccess, type AccessAnswer } from './resolveAccess'
import { resolveAvailability } from './resolveAvailability'
import { ROUTE_REGISTRY_ENTRIES } from './routeRegistry'
import { useAvailabilityInputs } from './useAvailabilityInputs'
import { useRoleAccessContext } from './useRoleAccessContext'
import type { RouteKey } from '@omnea-app/fe-routing/routes/routeKeys'

/**
 * What every route answers for the current caller, so enforcement and the links that point at a route
 * cannot disagree.
 */
export const useRouteAccess = (): ReadonlyMap<RouteKey, AccessAnswer> => {
  const availabilityInputs = useAvailabilityInputs()
  const authzContext = useFullAuthzContext()
  const roleContext = useRoleAccessContext()

  return useMemo(() => {
    const answers = new Map<RouteKey, AccessAnswer>()

    for (const [key, definition] of ROUTE_REGISTRY_ENTRIES) {
      const availability = resolveAvailability(definition.availability, availabilityInputs)
      answers.set(key, resolveAccess(definition.access, availability, authzContext, roleContext))
    }

    return answers
  }, [availabilityInputs, authzContext, roleContext])
}
